import React, { useState } from 'react';
import './WaitlistSignup.css';

const WaitlistSignup: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');
  const [waitlistData, setWaitlistData] = useState<any>(null);

  const validateEmail = (email: string): boolean => {
    return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage('');

    if (!email) {
      setMessage('Please enter your email');
      setIsSubmitting(false);
      return;
    }

    if (!validateEmail(email)) {
      setMessage('Please enter a valid email');
      setIsSubmitting(false);
      return;
    }

    try {
      const response = await fetch('https://api.getwaitlist.com/api/v1/signup', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          waitlist_id: 23929, // Updated with your waitlist ID
          referral_link: window.location.href
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setWaitlistData(data);
      } else {
        setMessage(data.message || 'Something went wrong. Please try again.');
      }
    } catch (error) {
      console.error('Submission error:', error);
      setMessage('Something went wrong. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (waitlistData) {
    return (
      <div className="waitlist-signup">
        <div className="success-message">
          <p>Thank you for signing up! We'll be in touch soon.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="waitlist-signup">
      <form onSubmit={handleSubmit}>
        <div className="input-group">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            required
            disabled={isSubmitting}
          />
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Joining...' : 'Join Waitlist'}
          </button>
        </div>
        {message && <p className="message error">{message}</p>}
      </form>
    </div>
  );
};

export default WaitlistSignup; 